import React from 'react';
import './docs.css';

const DocsPage = () => {
  return (
    <div className="docs-container">
      <header className="docs-header">
        <h1>API Documentation</h1>
        <p>API documentation for bakery management system</p>
      </header>

      <div className="docs-content">
        <nav className="docs-nav">
          <h3>Endpoints</h3>
          <ul>
            <li><a href="#getBill">GET /api/getBill</a></li>
          </ul>
        </nav>

        <main className="docs-main">
          <section id="getBill" className="endpoint-section">
            <h2>GET /api/getBill</h2>
            <div className="endpoint-badge" style={{
              display: 'grid',
              gridTemplateColumns: '130px 1fr', // cột trái cố định
              alignItems: 'center',
              marginBottom: '8px'
            }}>
              <span className="method-get" style={{
                background: '#2ecc71',
                color: '#fff',
                padding: '4px 8px',
                borderRadius: '4px',
                fontWeight: 'bold',
                display: 'inline-block',
                width: '100px', // tất cả cùng width
                textAlign: 'center'
              }}>GET</span>
              <span className="endpoint-url">/api/getBill</span>
            </div>

            <div className="endpoint-badge" style={{
              display: 'grid',
              gridTemplateColumns: '130px 1fr',
              alignItems: 'center',
              marginBottom: '8px'
            }}>
              <span className="method-get" style={{
                background: '#27ae60',
                color: '#fff',
                padding: '4px 8px',
                borderRadius: '4px',
                fontWeight: 'bold',
                display: 'inline-block',
                width: '100px',
                textAlign: 'center'
              }}>Request URL</span>
              <span className="endpoint-url">https://doticom.vn:3000</span>
            </div>


            <div className="description">
              <h3>Description</h3>
              <p>Lấy danh sách hóa đơn bán hàng trong khoảng thời gian cụ thể cho một cửa hàng.</p>
            </div>

            <div className="authentication">
              <h3>Authentication</h3>
              <p><strong>Required: </strong> token</p>
              <div className="auth-example">
                <h4>Header:</h4>
                <pre><code>token: &lt;your-token&gt;</code></pre>
              </div>
            </div>

            <div className="parameters">
              <h3>Query Parameters</h3>
              <table className="params-table">
                <thead>
                  <tr>
                    <th>Parameter</th>
                    <th>Type</th>
                    <th>Required</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><code>MaCH</code></td>
                    <td>string</td>
                    <td>✅ Yes</td>
                    <td>Mã cửa hàng</td>
                  </tr>
                  <tr>
                    <td><code>StartDay</code></td>
                    <td>date</td>
                    <td>✅ Yes</td>
                    <td>Ngày bắt đầu (YYYY-MM-DD)</td>
                  </tr>
                  <tr>
                    <td><code>EndDay</code></td>
                    <td>date</td>
                    <td>✅ Yes</td>
                    <td>Ngày kết thúc (YYYY-MM-DD)</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="request-example">
              <h3>Request Example</h3>
              <pre><code>{`GET /api/getBill?MaCH=CH001&StartDay=2024-01-01&EndDay=2024-01-31
token: eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...`}</code></pre>
            </div>

            <div className="responses">
              <h3>Responses</h3>

              <div className="response-success">
                <h4>✅ 200 OK</h4>
                <p>Danh sách hóa đơn được trả về thành công</p>
                <pre><code>{`[
  {
    "IDXuat": "PX001",
    "IDTimeXuat": "202401011030",
    "MaPX": "PX001",
    "SoPX": "001",
    "MaSoBan": "B01",
    "MaKH": "KH001",
    "MaCH": "CH001",
    "NgayXuat": "2024-01-01T10:30:00.000Z",
    "MaTheVIP": null,
    "GiamPT": 0,
    "VAT": 10,
    "GiamTM": 0,
    "PhiDVPT": 0,
    "GiamTMTheVIP": 0,
    "TongTien": 150000,
    "TTtienThe": 0,
    "TienCuaKhach": 150000,
    "TienThuaKhach": 0,
    "MaHTTT": "TM",
    "GhiChu": "",
    "TenUser": "admin",
    "TenKH": "Nguyen Van A",
    "LoaiKH": "VL",
    "MaCK": null,
    "LoaiPhieu": "BH",
    "Act_Bill": 1,
    "ThietBi": "POS01",
    "Act_T": 1,
    "TraCuu_VAT": 1,
    "HeSoTichDiem": 1,
    "TieuDiem": 0,
    "ChiTiet": [
      {
        "IDXuatCT": "CT001",
        "IDXuat": "PX001",
        "MaSP": "SP001",
        "TenSP": "Bánh mì thịt",
        "SoLuong": 2,
        "GiaBan": 25000,
        "GiamPT": 0,
        "ThanhTien": 50000,
        "MXTY": null,
        "ThoiGianChon": "2024-01-01T10:30:00.000Z",
        "GhiChuCT": "",
        "TenUser": "admin",
        "MaCH_CT": "CH001",
        "MaSaleOrder": null,
        "VAT": 10
      }
    ]
  }
]`}</code></pre>
              </div>

              <div className="response-error">
                <h4>❌ 400 Bad Request</h4>
                <p>Thiếu tham số bắt buộc</p>
                <pre><code>{`{
  "message": "Thiếu MaCH, StartDay hoặc EndDay"
}`}</code></pre>
              </div>

              <div className="response-error">
                <h4>❌ 401 Unauthorized</h4>
                <p>Token không hợp lệ hoặc không được cung cấp</p>
                <pre><code>{`{
  "message": "Token không hợp lệ."
}`}</code></pre>
              </div>

              <div className="response-error">
                <h4>❌ 500 Internal Server Error</h4>
                <p>Lỗi server hoặc database</p>
                <pre><code>{`{
  "message": "Lỗi server",
  "error": "Database connection failed"
}`}</code></pre>
              </div>
            </div>

            <div className="response-schema">
              <h3>Response Schema</h3>
              <h4>Bill Object</h4>
              <table className="schema-table">
                <thead>
                  <tr>
                    <th>Field</th>
                    <th>Type</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>IDXuat</td><td>string</td><td>ID phiếu xuất</td></tr>
                  <tr><td>IDTimeXuat</td><td>string</td><td>Thời gian xuất</td></tr>
                  <tr><td>MaPX</td><td>string</td><td>Mã phiếu xuất</td></tr>
                  <tr><td>SoPX</td><td>string</td><td>Số phiếu xuất</td></tr>
                  <tr><td>MaSoBan</td><td>string</td><td>Mã số bàn</td></tr>
                  <tr><td>MaKH</td><td>string</td><td>Mã khách hàng</td></tr>
                  <tr><td>MaCH</td><td>string</td><td>Mã cửa hàng</td></tr>
                  <tr><td>NgayXuat</td><td>datetime</td><td>Ngày xuất hàng</td></tr>
                  <tr><td>TongTien</td><td>number</td><td>Tổng tiền hóa đơn</td></tr>
                  <tr><td>TenKH</td><td>string</td><td>Tên khách hàng</td></tr>
                  <tr><td>ChiTiet</td><td>array</td><td>Danh sách chi tiết sản phẩm</td></tr>
                </tbody>
              </table>

              <h4>Bill Detail Object</h4>
              <table className="schema-table">
                <thead>
                  <tr>
                    <th>Field</th>
                    <th>Type</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>IDXuatCT</td><td>string</td><td>ID chi tiết xuất</td></tr>
                  <tr><td>MaSP</td><td>string</td><td>Mã sản phẩm</td></tr>
                  <tr><td>TenSP</td><td>string</td><td>Tên sản phẩm</td></tr>
                  <tr><td>SoLuong</td><td>number</td><td>Số lượng</td></tr>
                  <tr><td>GiaBan</td><td>number</td><td>Giá bán</td></tr>
                  <tr><td>ThanhTien</td><td>number</td><td>Thành tiền</td></tr>
                </tbody>
              </table>
            </div>

            <div className="notes">
              <h3>Notes</h3>
              <ul>
                <li>Endpoint này yêu cầu xác thực token trong header</li>
                <li>Thời gian được so sánh theo ngày (không tính giờ)</li>
                <li>Dữ liệu trả về bao gồm cả thông tin phiếu và chi tiết sản phẩm</li>
                <li>Nếu không có dữ liệu, trả về mảng rỗng []</li>
              </ul>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default DocsPage;
